import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const Chargebacks = () => {
  const information = [];

  const schemeBodyTemplate = (rowData) => (
    <div className="text-text-orange text-center font-bold bg-text-orange/10 w-[100.97px] h-[30px] rounded-lg py-1">
      {rowData.scheme}
    </div>
  );

  return (
    <div>
      <div className="flex items-center justify-evenly">
        <h1 className="text-navy-blue text-2xl font-bold">Transactions - CB</h1>
        <div className="relative">
          <input
            type="text"
            placeholder="search"
            className="w-[402px] h-[40px] rounded-[10px] px-2 border border-gray-300"
          />
          <span>
            <svg
              className="absolute right-8 top-3"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.5">
                <path
                  d="M7.22235 13.4445C10.6589 13.4445 13.4447 10.6587 13.4447 7.22223C13.4447 3.78579 10.6589 1 7.22235 1C3.78584 1 1 3.78579 1 7.22223C1 10.6587 3.78584 13.4445 7.22235 13.4445Z"
                  stroke="#030229"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15.0001 15.0005L11.6167 11.6172"
                  stroke="#030229"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </svg>
          </span>
        </div>
        <div className="bg-white w-[130px] h-[40px] rounded-[5px] flex items-center justify-between px-2">
          <div className="font-semibold text-sm text-gray-400">Start Date</div>
          <span>
            <svg
              className="mt-1"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.5"
                d="M1 1L5 5L9 1"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
        <div className="bg-white w-[130px] h-[40px] rounded-[5px] flex items-center justify-between px-2">
          <div className="font-semibold text-sm text-gray-400">End Date</div>
          <span>
            <svg
              className="mt-1"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.5"
                d="M1 1L5 5L9 1"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
        <div className="relative">
          <button className="text-white bg-text-orange w-[165px] h-[42px] rounded-[10px]">
            Export
          </button>
          <span>
            <svg
              className="absolute left-10 top-[18px]"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_22_2583)">
                <path
                  d="M6.91242 3.75H6.24992V1.66667C6.24992 1.4375 6.06242 1.25 5.83325 1.25H4.16659C3.93742 1.25 3.74992 1.4375 3.74992 1.66667V3.75H3.08742C2.71659 3.75 2.52909 4.2 2.79159 4.4625L4.70409 6.375C4.86659 6.5375 5.12909 6.5375 5.29159 6.375L7.20409 4.4625C7.46659 4.2 7.28325 3.75 6.91242 3.75ZM2.08325 7.91667C2.08325 8.14583 2.27075 8.33333 2.49992 8.33333H7.49992C7.72909 8.33333 7.91659 8.14583 7.91659 7.91667C7.91659 7.6875 7.72909 7.5 7.49992 7.5H2.49992C2.27075 7.5 2.08325 7.6875 2.08325 7.91667Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_22_2583">
                  <rect width="10" height="10" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
        </div>
      </div>
      {information.length === 0 ? (
        <div className="bg-white h-screen mt-4 ml-11 px-12 py-5 ">
          <p className="text-[50px] font-bold w-[715px]">
            You do not have any chargebacks to process at the moment.
          </p>
          <p className="text-xl font-bold mt-6 w-[640px]">
            Your customers might be looking for ways to pay you, create a
            payment link.
          </p>
          <div className="mt-8 relative">
            <span className="absolute left-10 top-2 text-white">+</span>
            <button className="bg-text-orange text-white w-[272px] h-[42px] rounded-[10px]">
              Create a payment link
            </button>
          </div>
        </div>
      ) : (
        <div className="bg-white w-[1235px] mt-4 ml-11 px-12 py-5 rounded-lg shadow-sm">
          <div className="card overflow-x-auto w-full">
            <DataTable
              value={information}
              paginator={information.length > 10}
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              emptyMessage="No chargebacks found"
              stripedRows
              responsiveLayout="scroll"
              className="p-datatable-sm"
            >
              <Column field="id" header="#" sortable />
              <Column field="masked" header="Masked PAN" sortable />
              <Column field="description" header="Description" sortable />
              <Column field="order_id" header="Order ID" sortable />
              <Column field="payment_ref" header="Payment Ref." sortable />
              <Column
                field="scheme"
                header="Scheme"
                body={schemeBodyTemplate}
                sortable
              />
              <Column field="amount" header="Total Amount" sortable />
            </DataTable>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chargebacks;
